// extracted by mini-css-extract-plugin
export default {"area":"_3xvFr","mobile":"cwKrG","label":"MvpGA"};